/** Rate scale colors — red (min) → yellow → green (max) */

export const MS_TO_KMH = 3.6

export function toDisplayRate(value, workingSpeed) {
    const n = Number(value)
    if (!Number.isFinite(n)) {
        return null
    }
    return workingSpeed ? n * MS_TO_KMH : n
}

export const RATE_GRADIENT_STOPS = [
    { t: 0, hex: '#ff0000' },
    { t: 0.5, hex: '#ffff00' },
    { t: 1, hex: '#008000' },
]

export const RATE_LEGEND_GRADIENT = 'linear-gradient(to right, #ff0000 0%, #ffff00 50%, #008000 100%)'

function hexToRgb(hex) {
    const clean = (hex || '#999999').replace('#', '')
    const bigint = parseInt(clean, 16)

    return {
        r: (bigint >> 16) & 255,
        g: (bigint >> 8) & 255,
        b: bigint & 255,
    }
}

function rgbToHex(r, g, b) {
    const toHex = (value) => Math.round(value).toString(16).padStart(2, '0')
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}

function interpolateHex(t) {
    const clamped = Math.max(0, Math.min(1, t))

    for (let i = 0; i < RATE_GRADIENT_STOPS.length - 1; i++) {
        const left = RATE_GRADIENT_STOPS[i]
        const right = RATE_GRADIENT_STOPS[i + 1]

        if (clamped <= right.t) {
            const span = right.t - left.t || 1
            const localT = (clamped - left.t) / span
            const from = hexToRgb(left.hex)
            const to = hexToRgb(right.hex)

            return rgbToHex(
                from.r + (to.r - from.r) * localT,
                from.g + (to.g - from.g) * localT,
                from.b + (to.b - from.b) * localT,
            )
        }
    }

    return RATE_GRADIENT_STOPS[RATE_GRADIENT_STOPS.length - 1].hex
}

export function getRateHex(rate, minRate, maxRate) {
    const value = Number(rate)
    const min = Number(minRate)
    const max = Number(maxRate)

    if (!Number.isFinite(value) || !Number.isFinite(min) || !Number.isFinite(max)) {
        return '#999999'
    }

    if (max <= min) {
        return interpolateHex(0.5)
    }

    return interpolateHex((value - min) / (max - min))
}
